import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ItemClickEvent} from 'devextreme/ui/list';
import {TemplateItem} from 'app/Model/Catalog/TemplateItem';
import {NextPimField} from 'app/Model/Catalog/NextPimField';
import {fieldNames} from 'app/Model/FieldNames';
import {comparePimFields, fillLastKey, isNextPimField, parsePimField} from 'app/Services/templateItemHelpers';
import {TemplateService} from 'app/Services/template.service';
import {TemplateItemTemplate} from '../../Model/Catalog/TemplateItemTemplate';
import {TemplateFieldsService} from "../../Services/templateFields.service";
import {LoginService} from "../../Services/login.service";

@Component({
    selector: 'np-advanced-template-price',
    templateUrl: './advanced-template-price.component.html',
    standalone: false
})
export class AdvancedTemplatePriceComponent implements OnInit {
  @Input() templateItem: TemplateItem;
  @Output() onUpdate = new EventEmitter<void>();

  fieldList: TemplateItemTemplate[] = this.fieldService.pricelistFields;

  get elementKey(): number {
    return this.parseInt(this.pimField.elementKey);
  }

  set elementKey(value: number) {
    this.pimField.elementKey = value.toString();
  }

  get systemKey(): number {
    return this.parseInt(this.pimField.systemKey);
  }

  set systemKey(value: number) {
    this.pimField.systemKey = value.toString();
  }

  get needsElement() {
    const templateItemTemplates = this.fieldList.filter((x) => x.field === this.pimField.field);
    if (templateItemTemplates?.length > 0) {
      return templateItemTemplates[0].element;
    }
    return false;
  }

  get pimField() {
    if (!this.templateItem.pimFields || this.templateItem.pimFields.length === 0) {
      this.templateItem.pimFields = [new NextPimField('-1', '1', fieldNames.startDate)];
    }
    return this.templateItem.pimFields[0];
  }

  constructor(private templateService: TemplateService, private translate: TranslateService, private fieldService: TemplateFieldsService, private loginService: LoginService) {
  }

  ngOnInit() {
    this.normalizeKeys();
  }

  getFieldDisplayExpr(item: TemplateItemTemplate) {
    return item?.text === item?.field ? item?.field ?? '' : `${item.text} (${item.field})`;
  }

  onFieldItemClick(event: ItemClickEvent<TemplateItemTemplate>) {
    this.pimField.field = event.itemData.field;
    this.update();
  }

  onOrderChanged() {
    this.update();
  }

  update() {
    const { field, systemKey, elementKey } = this.pimField;
    const parsedKey = parsePimField(this.templateItem.key);
    this.normalizeKeys();

    if (parsedKey !== null && (comparePimFields(parsedKey, this.pimField) || !isNextPimField(parsedKey.field))) {
      this.onUpdate.emit();
      return;
    }
    this.templateService.getHeadline(field, elementKey, systemKey, this.loginService.currentCustomer.id).subscribe((headline) => {
      fillLastKey(this.templateItem, headline.value);
      this.onUpdate.emit();
    });
  }

  private normalizeKeys(systemKey?: string, elementKey?: string) {
    systemKey = systemKey ?? this.pimField.systemKey;
    elementKey = elementKey ?? this.pimField.elementKey;
    if (systemKey === '-1' || !/^\d+$/.test(systemKey)) {
      this.pimField.systemKey = '1';
    } else {
      this.pimField.systemKey = systemKey.toString();
    }
    if (this.needsElement) {
      if (elementKey === '-1' || !/^\d+$/.test(elementKey)) {
        this.pimField.elementKey = '1';
      } else {
        this.pimField.elementKey = elementKey.toString();
      }
    } else {
      this.pimField.elementKey = '-1';
    }
  }

  protected readonly parseInt = parseInt;
}
